export enum CorrelationReportParametersControlKey {
  Map = 'map',
  StreetView = 'streetView',
  CorrelationGraph = 'correlationGraph',
  CorrelationSpectrum = 'correlationSpectrum',
  SpectrumOfBothLoggers = 'spectrumOfBothLoggers',
  NoiseLevelHistory = 'noiseLevelHistory',
}
